import styles from "./LoadingDots.module.scss";
export default function LoadingDots({ white }) {
  return (
    <div className={`${styles.dots} ${white ? styles.whiteDot : ""}`}>
      <div className={styles.dot1}></div>
      <div className={styles.dot2}></div>
      <div className={styles.dot3}></div>
    </div>
  );
}
